import {Typography} from '@mui/material';
import Box, {BoxProps} from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Iconify from '../iconify';

// ----------------------------------------------------------------------

interface LoadingScreenProps extends BoxProps {
  // eslint-disable-next-line react/boolean-prop-naming
  search?: boolean;
}

export default function LoadingScreen({
  search,
  sx,
  ...other
}: LoadingScreenProps): JSX.Element {
  return (
    <Box
      sx={{
        px: 5,
        width: 1,
        flexGrow: 1,
        minHeight: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx
      }}
      {...other}>
      {search ? (
        <>
          <Typography
            sx={{
              fontSize: '2rem !important'
            }}>
            searching
          </Typography>
          <Iconify
            icon="svg-spinners:bars-fade"
            width="2rem"
            height="2rem"
            sx={{
              color: 'black',
              mt: '8px',
              ml: '10px'
            }}
          />
        </>
      ) : (
        <LinearProgress sx={{width: 1, maxWidth: 360}} />
      )}
    </Box>
  );
}
